<!--
 * @Author: lan.h
 * @Date: 2022-02-22 10:14:59
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:10:32
 * @Description: 热点文章
-->
<template>
  <div class="seven_hot" v-if="article.length > 0">
    <div class="mode-title">
      <span class="title-p">热点文章</span>
    </div>
    <ul class="sev_cnt">
      <li v-for="a, index in article" :key="index">
        <a class="hot-1" v-if="index == 0" @click="toArticle(a)"> 
          <div class="top1">TOP1</div>
          <img :src="a.logoPath | logo_show">
          <p>{{a.title}}</p>
          <div class="hot-mask"></div>
        </a> 
        <div class="hot-2" v-else @click="toArticle(a)">
          <div class="left">
            <img :src="a.logoPath | logo_show">
            <div class="top2">{{index +1}}</div>
          </div>
          <div class="right">
            <h1 class="over-p2">{{a.title}}</h1>
            <p class="hot-p2">{{a.publishTime | time_standard}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { hotarticle } from "../../service";
export default {
  props: {
    pageType: {
      default: ''    //1首页
    }
  },
  data() {
    return {
      article: [],
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      let res = await hotarticle( {}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'article', res.data)
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    toArticle(a) {
      const href = this.$store.state.index2_path + '/' + a.id
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧热门文章(文章标题/图片)', '点击量'])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.seven_hot 
  width 100%
  .sev_cnt
    li 
      margin-top 18px
      .hot-1, .hot-2 
        img 
          width 100% 
          height 100% 
      .hot-1
        display block 
        height 215px
        position relative
        overflow hidden
        &:hover
          img 
            transform scale(1.1)
            transition all 0.6s ease 0s
        .top1
          width 36px
          height 23px
          background-color rgba(#FA5A00 0.8)
          color #fff
          position absolute
          top 12px 
          left 12px
          font-size 12px
          text-align center 
          line-height 23px
          font-weight bold
          z-index 1
        p 
          position absolute
          bottom 20px 
          padding 0 14px
          left 0
          font-size 14px
          font-weight 500
          line-height 20px  
          z-index 2
          color #FFFFFF
          &:hover 
            transition all 0.5s
            color #FA5A00
        .hot-mask
          position absolute
          bottom 0 
          left 0
          width 100% 
          height 50%
          background linear-gradient(transparent, #000)
          z-index 1
      .hot-2
        display flex
        justify-content space-between
        cursor pointer
        .left 
          position relative
          width 108px
          height 68px
          overflow hidden
          &:hover
            img 
              transform scale(1.1)
              transition all 0.6s ease 0s
          .top2
            position absolute
            left 0
            top 0
            color #fff
            font-size 12px
            font-weight bold
            background-color rgba(#FA5A00 0.8)
            border-radius 0px 0px 6px 0px
            width 16px
            height 23px
            text-align center 
            line-height 23px  
        .right
          margin-left 15px
          width calc(100% - 123px)
          h1 
            line-height 18px
            font-size 14px
            font-weight 500
            font-size 14px
            color #333333
            height 36px
            &:hover 
              transition all 0.5s
              color #FA5A00
          p 
            font-size 12px
            font-weight 500
            color #999999
            line-height 1
            margin-top 20px
    li:nth-child(4), li:nth-child(5)
      .hot-2
        .left
          .top2
            background-color rgba(#333 0.5)
</style>